import { SetState, GetState } from 'zustand';

export interface IActiveTransactionSlice {
    activeTransaction: any;
    setActiveTransaction: (transaction: any) => void;
    getActiveTransaction: () => any;
    resetActiveTransactions: () => void;
}

const createActiveTransactionSlice = (set: SetState<IActiveTransactionSlice>, get: GetState<IActiveTransactionSlice>) => ({
  activeTransaction: {},
  setActiveTransaction: (transaction: any) => {
    set({
      activeTransaction: transaction,
    });
  },
  getActiveTransaction: () => get().activeTransaction,
  resetActiveTransactions: () => {
    set({ activeTransaction: {} });
  },
});

export default createActiveTransactionSlice;
